<template>
	<!-- This template has *buttons* that call a *method* which manipulates *data*,
 which is passed to the line chart component as *props*, triggering rerender -->
	<div class="chart-container">
		<!-- Subject refers to the type of data being asked to plot -->
		<div class="subject__btns relativeclass">
			<b-button
				:class="
					this.subject === 'testsTaken' ? 'usage-active' : 'usage-nonactive'
				"
				v-on:click="setSubject('testsTaken')"
				>Tests Taken</b-button
			>
			<b-button
				:class="
					this.subject == 'testsCreated' ? 'usage-active' : 'usage-nonactive'
				"
				v-on:click="setSubject('testsCreated')"
				>Tests Created</b-button
			>
			<b-button
				:class="
					this.subject == 'topicsCreated' ? 'usage-active' : 'usage-nonactive'
				"
				v-if="!topicId"
				v-on:click="setSubject('topicsCreated')"
				>Topics Created</b-button
			>

			<div class="button-line"></div>
			<div class="chart mt-3">
				<div class="time__btns">
					<b-select
						class="usageLineSelect"
						v-model="time"
						:options="timeDropdown"
					></b-select>
				</div>
				<LineChart :topicId="topicId" :time="time" :subject="subject" />
			</div>
		</div>
	</div>
</template>

<script>
import LineChart from "./LineChart.vue";

export default {
	name: "UsageLine",
	data() {
		return {
			topicId: this.$route.params.topicID || null,
			lineData: {},
			subject: "testsTaken",
			time: "all",
			timeDropdown: [
				{ value: "all", text: "All" },
				{ value: "year", text: "Year", disabled: new Date().getMonth() === 0 },
				{ value: "month", text: "Month" },
				{ value: "week", text: "Week" },
			],
		};
	},

	methods: {
		setTime(time) {
			this.time = time;
		},
		setSubject(subject) {
			this.subject = subject;
		},
	},
	components: {
		LineChart,
	},
};
</script>

<style>
.time__btns {
	width: 10%;
	margin-left: auto;
}
.time__btns > select {
	border: none;
	border-radius: 0;
	outline: none;
	border-bottom: solid 1px #72738e;
}
.usageLineSelect {
	background: url("../../../assets/downarrow.svg") right 0.75rem center/8px 10px
		no-repeat;
}
.custom-select:focus {
	border-color: inherit !important;
	-webkit-box-shadow: none !important;
	box-shadow: none !important;
}
</style>
